import { render, staticRenderFns } from "./AddPatientDialog.vue?vue&type=template&id=4c4834c4"
import script from "./AddPatientDialog.vue?vue&type=script&lang=js"
export * from "./AddPatientDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports